<template>
  <section class="lms-container">
    <div class="content">
    <div class="breadcrumb" style="border: none !important;"></div>

      <div style="padding-bottom:15px;" class="form-actions">
        <button
          :disabled="saving || !(product.thumbPath || product.thumbPath == '' )"
          v-on:click="save"
          type="submit"
          class="btn btn-primary btn-medium"
        >
          <i class="icon-save"></i>&nbsp;Gravar
        </button>
        <a id="save_student_" v-on:click="$router.push({ name: 'products'})" class="back-button">
          <i class="icon-circle-arrow-left"></i>&nbsp;Voltar
        </a>
      </div>

      <tabs>
        <tab class="col-container" title="Produto">
          <div class="col col-lg-6">
            <file-upload
              :class="{ 'has-error': $v.product.thumbPath.$error }"
              v-on:uploadComplete="updatePath"
              class
              :field="'Banner'"
              :filetype="'.jpg'"
            />

            <img
              :key="imageKey"
              v-bind:src="product.thumbPath"
              class="img-responsive img-thumbnail"
              alt="thumbnail do produto"
            />
            <!-- <banner style="margin-top:15px;" :course="course" :isEdit="true" /> -->
          </div>
          <div class="col col-lg-6">
            <div class="row">
              <div :class="{ 'has-error': $v.product.name.$error }" class="control-group col-lg-12">
                <label class="control-label" for="name">Nome *</label>

                <div class="controls">
                  <input id="name" type="text" v-model="product.name" class="form-control" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="control-group col-lg-6">
                <label class="control-label" for="daysAvailable">Disponibilidade *</label>

                <div class="controls">
                  <div class="input-group">
                    <date-input
                      v-if="avaliableIsDate"
                      class="form-control"
                      v-model="product.timestampAvailable"
                    ></date-input>
                    <input
                      v-else
                      id="daysAvailable"
                      type="number"
                      v-model="product.daysAvailable"
                      class="form-control"
                    />

                    <!-- <a
                      @click="avaliableIsDate = false"
                      class="input-group-addon btn btn-success"
                      href="#"
                      role="button"
                    >Dias</a>
                    <a
                      @click="avaliableIsDate = true"
                      class="input-group-addon btn btn-success"
                      href="#"
                      role="button"
                    >Data</a> -->
                  </div>
                </div>
              </div>

              <div :class="{ 'has-error': $v.product.value.$error }" class="control-group col-lg-3">
                <label class="control-label" for="name">Valor *</label>

                <div class="controls">
                  <input id="name" type="number" v-model="product.value" class="form-control" />
                </div>
              </div>

              <!-- <div class="form-check">
                <input type="checkbox" class="form-check-input" id="exampleCheck1" />
                <label class="form-check-label" for="exampleCheck1">Destaque</label>
              </div>-->

              <div
                :class="{ 'has-error': $v.product.isFeatured.$error }"
                class="control-group col-lg-3"
              >
                <label class="control-label" for="name">Destaque *</label>

                <div class="controls">
                  <input
                    id="name"
                    type="checkbox"
                    v-model="product.isFeatured"
                    class="form-check-input"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div
                :class="{ 'has-error': $v.product.categoryId.$error }"
                class="control-group col-lg-6"
              >
                <label class="control-label" for="category">Categoria *</label>
                <div class="controls">
                  <div class="input-group">
                    <input
                      v-if="addCategory"
                      id="neCcategory"
                      type="text"
                      v-model="newCategory.name"
                      class="form-control"
                    />

                    <select v-else v-model="product.categoryId" id="category" class="form-control">
                      <option disabled value>Escolha uma categoria</option>
                      <option
                        v-for="c in categoryList"
                        v-bind:key="c.id"
                        v-bind:value="c.id"
                      >{{c.name}}</option>
                    </select>
                    <a
                      :disabled="savingCategory"
                      v-if="addCategory"
                      class="input-group-addon btn btn-success"
                      href="#"
                      role="button"
                      v-on:click="saveCategory"
                    >
                      <i class="fa fa-check"></i>
                    </a>

                    <a
                      v-if="addCategory"
                      class="input-group-addon btn btn-danger"
                      href="#"
                      role="button"
                      v-on:click="addCategory=false"
                    >
                      <i class="fa fa-ban"></i>
                    </a>
                    <a
                      v-else
                      class="input-group-addon btn btn-primary"
                      href="#"
                      role="button"
                      v-on:click="addCategory=true"
                    >
                      <i class="fa fa-plus-circle"></i>
                    </a>
                  </div>
                </div>
              </div>

              <div class="control-group col-lg-6">
                <label class="control-label" for="subcategory">Subcategoria *</label>
                <div class="controls">
                  <div class="input-group">
                    <input
                      v-if="addSubCategory"
                      id="neCcategory"
                      type="text"
                      v-model="newSubCategory.name"
                      class="form-control"
                    />

                    <select
                      v-else
                      v-model="product.subcategoryId"
                      id="subcategory"
                      class="form-control"
                    >
                      <option disabled value>Escolha uma categoria</option>
                      <option
                        v-for="s in subcategoryList"
                        v-bind:key="s.id"
                        v-bind:value="s.id"
                      >{{s.name}}</option>
                    </select>
                    <a
                      :disabled="savingSubCategory"
                      v-if="addSubCategory"
                      class="input-group-addon btn btn-success"
                      href="#"
                      role="button"
                      v-on:click="saveSubCategory"
                    >
                      <i class="fa fa-check"></i>
                    </a>

                    <a
                      v-if="addSubCategory"
                      class="input-group-addon btn btn-danger"
                      href="#"
                      role="button"
                      v-on:click="addSubCategory=false"
                    >
                      <i class="fa fa-ban"></i>
                    </a>
                    <a
                      v-else
                      class="input-group-addon btn btn-primary"
                      href="#"
                      role="button"
                      v-on:click="addSubCategory=true"
                    >
                      <i class="fa fa-plus-circle"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div
                :class="{ 'has-error': $v.product.description.$error }"
                class="control-group col-lg-12"
              >
                <label class="control-label" for="description">Descrição *</label>

                <textarea
                  v-model="product.description"
                  class="form-control"
                  id="description"
                  rows="10"
                ></textarea>

                <!-- <div class="controls">
                  <input
                    id="description"
                    type="text"
                    v-model="product.description"
                    class="form-control"
                  />
                </div>-->
              </div>
            </div>
          </div>
        </tab>

        <tab title="Módulos">
          <product-lessons :product="product" :productModules="productModules" :courses="courses" />
        </tab>

        <tab title="Cupons">
          <product-coupons
            @update="getProductCoupons()"
            :product="product"
            :productCoupons="productCoupons"
            :couponsLoading="couponsLoading"
          />
        </tab>

        <tab title="Inscritos">
          <product-subscriptions
            @update="getProductSubscriptions()"
            :product="product"
            :productSubscriptions="productSubscriptions" 
          />
        </tab>

        <!-- <tab title="Turmas">
          <product-classes @update="getProductClasses()" :product="product" :productClasses="productClasses" :classesLoading="classesLoading"/>
        </tab>-->
      </tabs>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>


<script>
import axios from "axios";
import FileUpload from "../../Utils/FileUpload";
import Banner from "../../Banner";
import { required, minLength } from "vuelidate/lib/validators";
import ProductLessons from "./ProductLessons";
import ProductClasses from "./ProductClasses";
import ProductCoupons from "./ProductCoupons";
import ProductSubscriptions from "./ProductSubscriptions.vue";

axios.defaults.withCredentials = true;

export default {
  data() {
    return {
      productCoupons: [],
      productSubscriptions: [],
      couponsLoading: false,
      avaliableIsDate: true,
      classesLoading: false,
      productClasses: [],
      courses: [],
      productModules: [],
      savingSubCategory: false,
      savingCategory: false,
      saving: false,
      newCategory: {},
      addCategory: false,
      categoryList: [],
      newSubCategory: {},
      addSubCategory: false,
      subcategoryList: [],
      lessons: [],
      product: this.$store.getters.productEdit,
      imageKey: 0
    };
  },
  validations: {
    product: {
      name: { required },
      value: { required },
      thumbPath: { required },
      description: { required },
      categoryId: { required },
      isFeatured: { required }
    }
  },

  components: {
    "file-upload": FileUpload,
    "product-lessons": ProductLessons,
    "product-classes": ProductClasses,
    "product-coupons": ProductCoupons,
    "product-subscriptions": ProductSubscriptions
  },
  methods: {
    updatePath(value) {
      this.product.thumbPath = value;
      this.imageKey += 1;
    },
    getLessons() {
      const path = this.$global.endpoint + "/product/lessons";
      axios
        .post(path, {
          productId: this.product.id
        })
        .then(res => {
          this.lessons = res.data;
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    getCategories() {
      const path = this.$global.endpoint + "/product/category/getall";
      axios
        .get(path)
        .then(res => {
          this.categoryList = res.data;
          console.log(this.categoryList);
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    saveCategory() {
      this.savingCategory = true;
      const path = this.$global.endpoint + "/product/admin/category/save";
      axios
        .post(path, { category: this.newCategory })
        .then(res => {
          this.product.categoryId = res.data.id;
          this.getCategories();
          this.addCategory = false;
          this.savingCategory = false;
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Categoria criada com sucesso"
          });
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
          this.savingCategory = false;
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: "Erro ao criar categoria"
          });
        });
    },
    getProductSubscriptions(){
      
      const path = this.$global.endpoint + "/user/admin/getall/product";

      axios
        .post(path, { productId: this.product.id })
        .then(res => {
          this.users = res.data;
          this.$emit("update");
          this.loadingSubscriptions = false;
        })
        .catch(error => {
          this.loadingSubscriptions = false;
          console.error(error);
        });
    },
    save() {
      console.log("TÔ AQUI")
      if (this.product.isFeatured == undefined) {
        this.product.isFeatured = false;
      }

      if (this.avaliableIsDate) {
        delete this.product.daysAvailable;
      } else {
        delete this.product.timestampAvailable;
      }
      console.log(this.product);
      this.saving = true;
      this.$v.product.$touch();
      if (this.$v.product.$error) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Erro",
          text: "Dados não preenchidos"
        });
        this.saving = false;
        return;
      }

      if (this.product.thumbPath != null) {
        const path = this.$global.endpoint + "/product/admin/save";
        axios
          .post(path, { product: this.product })
          .then(res => {
            this.getProductModules();
            this.product.id = res.data.product.id;
            this.saving = false;
            this.$notify({
              type: "success",
              group: "foo",
              title: "Concluído",
              text: "Dados do produto salvos"
            });
          })
          .catch(error => {
            console.error(error);
            this.saving = false;
            this.$notify({
              type: "error",
              group: "foo",
              title: "Erro",
              text: "Erro ao salvar os dados do produto"
            });
          });
      } else {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Erro",
          text: "Banner não escolhido"
        });
        this.saving = false;
      }
    },
    getProductModules() {
      const path = this.$global.endpoint + "/product/admin/module/getall";
      // axios
      //   .post(path, { productId: this.product.id })
      //   .then(res => {
      //     this.productModules = res.data;
      //   })
      //   .catch(error => {
      //     console.error(error);
      //   });
    },
    getProductClasses() {
      this.classesLoading = true;
      const path = this.$global.endpoint + "/product/admin/class/getall";
      // axios
      //   .post(path, { productId: this.product.id })
      //   .then(res => {
      //     this.productClasses = res.data;
      //     this.classesLoading = false;
      //   })
      //   .catch(error => {
      //     console.error(error);
      //   });
    },
    getProductCoupons() {
      this.couponsLoading = true;
      const path = this.$global.endpoint + "/product/admin/coupon/getall";
      // axios
      //   .post(path, { productId: this.product.id })
      //   .then(res => {
      //     this.productCoupons = res.data;
      //     this.couponsLoading = false;
      //   })
      //   .catch(error => {
      //     console.error(error);
      //   });
    },
    getProductSubscriptions() { this.couponsLoading = false;
      // this.couponsLoading = true;
      // const path = this.$global.endpoint + "/product/admin/coupon/getall";
      // axios
      //   .post(path, { productId: this.product.id })
      //   .then(res => {
      //     this.productCoupons = res.data;
      //     this.couponsLoading = false;
      //   })
      //   .catch(error => {
      //     console.error(error);
      //   });
    },
    getSubCategories() {
      const path = this.$global.endpoint + "/product/subcategory/getall";
      axios
        .get(path)
        .then(res => {
          this.subcategoryList = res.data;
          console.log(this.subcategoryList);
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    saveSubCategory() {
      this.savingCategory = true;
      const path = this.$global.endpoint + "/product/admin/subcategory/save";
      axios
        .post(path, { subcategory: this.newSubCategory })
        .then(res => {
          this.product.subcategoryId = res.data.id;
          this.getSubCategories();
          this.addSubCategory = false;
          this.savingSubCategory = false;
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Subcategoria criada com sucesso"
          });
        })
        .catch(error => {
          console.error(error);
          this.savingSubCategory = false;
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: "Erro ao criar subcategoria"
          });
        });
    }
  },
  mounted() {
    
    this.getSubCategories();
    this.getCategories();
    this.getProductModules();
    this.getProductClasses();
    this.getProductCoupons();
    this.getProductSubscriptions();
    const path = this.$global.endpoint + "/course/getall";

    console.log("PRODUCT", this.product)
    axios
      .get(path)
      .then(res => {
        this.courses = res.data;
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>
